// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DatabaseSummaryStatsTableQueryVariables = Types.Exact<{
  organizationSlug?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type DatabaseSummaryStatsTableQuery = {
  __typename?: "GraphqlQuery";
  getSummaryStatsByDatabase: Array<{
    __typename?: "DatabaseSummaryStats";
    id: string;
    criticalsCount: number;
    warningsCount: number;
    queriesSlownessCount: number;
    unusedIndexesCount: number;
    database: {
      __typename?: "Database";
      id: string;
      displayName: string;
      datname?: string | null;
      server: {
        __typename?: "Server";
        id: string;
        humanId: string;
        name: string;
        hasRecentSnapshot: boolean;
        hasCriticalIssues: boolean;
      };
    };
  }>;
};

export const DatabaseSummaryStatsTableDocument = gql`
  query DatabaseSummaryStatsTable($organizationSlug: ID, $serverId: ID) {
    getSummaryStatsByDatabase(
      organizationSlug: $organizationSlug
      serverId: $serverId
    ) {
      id
      database {
        id
        displayName
        datname
        server {
          id
          humanId
          name
          hasRecentSnapshot
          hasCriticalIssues
        }
      }
      criticalsCount
      warningsCount
      queriesSlownessCount
      unusedIndexesCount
    }
  }
`;

/**
 * __useDatabaseSummaryStatsTableQuery__
 *
 * To run a query within a React component, call `useDatabaseSummaryStatsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseSummaryStatsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseSummaryStatsTableQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useDatabaseSummaryStatsTableQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >(DatabaseSummaryStatsTableDocument, options);
}
export function useDatabaseSummaryStatsTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >(DatabaseSummaryStatsTableDocument, options);
}
// @ts-ignore
export function useDatabaseSummaryStatsTableSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DatabaseSummaryStatsTableQuery,
  DatabaseSummaryStatsTableQueryVariables
>;
export function useDatabaseSummaryStatsTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseSummaryStatsTableQuery,
        DatabaseSummaryStatsTableQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DatabaseSummaryStatsTableQuery | undefined,
  DatabaseSummaryStatsTableQueryVariables
>;
export function useDatabaseSummaryStatsTableSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseSummaryStatsTableQuery,
        DatabaseSummaryStatsTableQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DatabaseSummaryStatsTableQuery,
    DatabaseSummaryStatsTableQueryVariables
  >(DatabaseSummaryStatsTableDocument, options);
}
export type DatabaseSummaryStatsTableQueryHookResult = ReturnType<
  typeof useDatabaseSummaryStatsTableQuery
>;
export type DatabaseSummaryStatsTableLazyQueryHookResult = ReturnType<
  typeof useDatabaseSummaryStatsTableLazyQuery
>;
export type DatabaseSummaryStatsTableSuspenseQueryHookResult = ReturnType<
  typeof useDatabaseSummaryStatsTableSuspenseQuery
>;
export type DatabaseSummaryStatsTableQueryResult = Apollo.QueryResult<
  DatabaseSummaryStatsTableQuery,
  DatabaseSummaryStatsTableQueryVariables
>;
